import {gql} from '@apollo/client';
import React from 'react';
import {connect} from 'react-redux';

import {DataPolicy, PolicySpec, POLICY_TEMPLATE_FRAGMENT} from 'auth/PolicyConstants';
import * as PolicyDAO from 'auth/PolicyDAO';
import * as PolicyReduxActions from 'auth/PolicyReduxActions';
import {DataPolicyPageQuery} from 'auth/settings/__generated/DataPolicyPageQuery';
import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {BenchlingState} from 'redux-stores/reduceApp';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import PolicyPage from './PolicyPage';

export const DATA_POLICY_PAGE_QUERY = gql`
  query DataPolicyPageQuery @skipAudit @engComponent(name: PERMISSIONS) {
    policyTemplate(policyType: DATA) {
      ...PolicyTemplate
    }
  }
  ${POLICY_TEMPLATE_FRAGMENT}
`;

function mapStateToProps(state: BenchlingState, props: Props): EnhancedProps {
  const dataPolicies = state.models.policies.dataPolicies;
  const dataPolicy = dataPolicies!.find((dp: DataPolicy) => dp.id === props.dataPolicyId)!;
  return {
    dataPolicy,
  };
}

interface Props {
  dataPolicyId: string;
}

interface EnhancedProps {
  dataPolicy: DataPolicy;
}

export type DataPolicyPageProps = Props & EnhancedProps;

interface State {
  initialSpec: PolicySpec | null;
}

export class DataPolicyPage extends React.Component<DataPolicyPageProps, State> {
  state: State = {
    initialSpec: null,
  };

  async componentDidMount(): Promise<void> {
    const result: {
      specByDataPolicyId: {[dataPolicyId: string]: PolicySpec};
    } = await PolicyReduxActions.getDataPolicies();
    const spec = result.specByDataPolicyId[this.props.dataPolicy.id];
    this.setState({
      initialSpec: spec,
    });
  }

  _updatePolicy = async (updatedSpec: PolicySpec): Promise<PolicySpec | null> => {
    const {spec} = await PolicyReduxActions.updateDataPolicy(this.props.dataPolicyId, updatedSpec);
    return spec;
  };

  render(): JSX.Element {
    return (
      <BenchlingQuery<DataPolicyPageQuery>
        query={DATA_POLICY_PAGE_QUERY}
        renderLoading={() => <CenteredHorizontalThrobber />}
      >
        {({policyTemplate}) =>
          !this.state.initialSpec ? (
            <CenteredHorizontalThrobber />
          ) : (
            <PolicyPage
              policy={this.props.dataPolicy}
              initialSpec={this.state.initialSpec}
              updatePolicy={this._updatePolicy}
              listingsTitle="Policies"
              policiesURL={PolicyDAO.getDataPoliciesURL()}
              policyTemplate={policyTemplate}
            />
          )
        }
      </BenchlingQuery>
    );
  }
}

export default connect(mapStateToProps)(DataPolicyPage);
